import React from 'react';
import PageHeader from '@salesforce/design-system-react/components/page-header';
import Icon from '@salesforce/design-system-react/components/icon';

const ShowcasePageWrapper = ({ title, description, icon = 'dashboard', iconCategory = 'standard', actions, children }) => (
  <div style={{ padding: '0' }}>
    <PageHeader
      icon={<Icon category={iconCategory} name={icon} size="large" />}
      label="Showcase"
      title={title}
      info={description}
      variant="record-home"
      onRenderActions={actions ? () => actions : undefined}
    />
    <div style={{ padding: '24px', backgroundColor: '#f3f3f3', minHeight: 'calc(100vh - 120px)' }}>
      {children}
    </div>
  </div>
);

export default ShowcasePageWrapper;
